import React from 'react'
import styles from './Community.module.scss';

import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import ArticleControl from '../../components/article/article_control/ArticleControl';

const categories = [
  {
    title : '자유게시판',
    id : 0,
    childCount : 0
  },
  {
    title : '게임게시판',
    id : 1,
    childCount : 3,
    children : [
      {
        title : 'AI 원카드',
        id : 2,
        parentId : 1
      },
      {
        title : 'Blockman Survival Battle',
        id : 3,
        parentId : 1
      },
      {
        title : 'Ki 로또',
        id : 4,
        parentId : 1
      }
    ]
  }
]

const categoriesDic = {
  0:{
    title:'자유게시판',
    id : 0,
    childCount : 0
  },
  1:{
    title:'게임게시판',
    id : 1,
    childCount : 3
  },
  2:{
    title:'AI 원카드',
    id : 2,
    parentId : 1,
    childCount : 0
  },
  3:{
    title:'Blockman Survival Battle',
    id : 3,
    parentId : 1,
    childCount : 0
  },
  4:{
    title:'Ki 로또',
    id : 4,
    parentId : 1,
    childCount : 0
  }
}

const Community = () => {
  return (
    <div>
      <Header/>

      <div id={styles.wrapper_body}>
        <ArticleControl title='커뮤니티' categories = {categories} categoriesDic = {categoriesDic}/>
      </div>

      <Footer/>
    </div>
  )
}

export default Community;